export default {"src":"/_next/static/media/coins.cbd6dbef.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};